import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { KENDO_FORMFIELD, KENDO_NUMERICTEXTBOX, KENDO_TEXTBOX } from '@progress/kendo-angular-inputs';
import { KENDO_LABEL } from '@progress/kendo-angular-label';
import { ControlWrapperComponent } from '@unity/forms/composed/control-wrapper/control-wrapper.component';

@Component({
  selector: 'unity-textbox-numeric-integer-control',
  standalone: true,
  imports: [KENDO_FORMFIELD, KENDO_TEXTBOX, KENDO_NUMERICTEXTBOX, KENDO_LABEL, ReactiveFormsModule, ControlWrapperComponent],
  templateUrl: './textbox-numeric-integer-control.component.html',
  styleUrl: './textbox-numeric-integer-control.component.scss',
})
export class TextboxNumericIntegerControlComponent {
  public readonly $control = input.required<FormControl>({ alias: 'control' });
  public readonly $displayName = input.required<string>({ alias: 'displayName' });
  public readonly $description = input.required<string>({ alias: 'description' });

  public readonly $showHint = input(true, { alias: 'showHint' });
  public readonly $spinners = input(true, { alias: 'spinners' });
  public readonly $spinnerStep = input(1, { alias: 'spinnerStep' });
}
